import { instance } from './index';
import { useQuery, useMutation, useQueryClient } from 'react-query';
import { MODAL_QUERY_NM } from './modal';
import { authExpired, getLocalStorage,  } from './auth';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

const contextPath = ['/clients','/clientStorages', '/bizNoInfo'];
const queryName = 'CLIENTS';

export const useGetTargetClient = (param) => {
    const queryClient = useQueryClient();
    const authInfo = getLocalStorage();
    return useQuery(
                [`${queryName}_TARGET`], 
                () => param ? getClients(param, authInfo ? authInfo.accessToken:'') : {},
                {
                    onError:(err)=> {console.log('useGetTargetClient',err);err.response.status===401 && authExpired(queryClient)}
                }
                );
}

export const useGetClients = (param) => {
    const queryClient = useQueryClient();
    const authInfo = getLocalStorage();
    return useQuery(
                [`${queryName}`], 
                () => getClients(param, authInfo ? authInfo.accessToken:''),
                {
                    refetchInterval:300000,
                    onSuccess:()=>queryClient.setQueryData(['REFRESH_TIME'],{time:new Date()}),
                    onError:(err)=> {console.log('useGetClients',err);err.response.status===401 && authExpired(queryClient)}
                }
                );
}

const getClients = async (param,accessToken) => {

    const cid = param ? `/${param}` : '';
    const url = contextPath[0]+cid;

    const retVal = await instance.get(url, {headers:{Authorization:`Bearer ${accessToken}`}})
                                    .then((res)=>{
                                        return res.data;
                                    })

    return retVal;

}

export const useSetClient = () => {
    const queryClient = useQueryClient();
    const authInfo = getLocalStorage();
    return useMutation(
        (sendParam) => {
            switch(sendParam.mode){
                case 'POST':
                    return postClient(sendParam, authInfo ? authInfo.accessToken:'');
                case 'PUT':
                    return putClient(sendParam, authInfo ? authInfo.accessToken:'');
                case 'DELETE':
                    return deleteClient(sendParam, authInfo ? authInfo.accessToken:'');
                default :
                    return putClient(sendParam, authInfo ? authInfo.accessToken:'');
            }
        },
        {
            onSuccess:()=>{
                queryClient.invalidateQueries([`${queryName}`], { refetchInactive: true })
                queryClient.invalidateQueries([`${queryName}_TARGET`], { refetchInactive: true })
            },
            onError:(err)=>{
                err.response.status===401 ? authExpired(queryClient)
                    : queryClient.setQueryData([MODAL_QUERY_NM],{show:true,msg:err.response.data.message})
            }
        }
    )
}

const postClient = async (param, accessToken) => {

    const sendParam = {
        cname: param.cname,
        alias: param.alias,
        biz_no: param.biz_no,
        biz_tp: param.biz_tp,
        owner_nm: param.owner_nm,
        mangr_nm: param.mangr_nm,
        zipcode: param.zipcode,
        addr: param.addr,
        phn_no_o: param.phn_no_o,
        phn_no_m: param.phn_no_m,
        fax_no: param.fax_no,
        email: param.email,
        descr: param.descr,
        memo: param.memo
    }

    const retVal = await instance.post(contextPath[0], sendParam,{headers:{Authorization:`Bearer ${accessToken}`}})
                                    .then((res)=>{
                                        return res;
                                    })
    return retVal;
}

const putClient = async (param, accessToken) => {

    const sendParam = {
        cid: param.cid,
        cname: param.cname,
        alias: param.alias,
        biz_no: param.biz_no,
        biz_tp: param.biz_tp,
        owner_nm: param.owner_nm,
        mangr_nm: param.mangr_nm,
        zipcode: param.zipcode,
        addr: param.addr,
        phn_no_o: param.phn_no_o,
        phn_no_m: param.phn_no_m,
        fax_no: param.fax_no,
        email: param.email,
        descr: param.descr,
        memo: param.memo
    }

    const retVal = await instance.put(contextPath[0], sendParam,{headers:{Authorization:`Bearer ${accessToken}`}})
                                    .then((res)=>{
                                        return res;
                                    })
    return retVal;

}

const deleteClient = async (param, accessToken) => {

    const retVal = await instance.delete(contextPath[0]+'/'+param.cid, {headers:{Authorization:`Bearer ${accessToken}`}})
                                    .then((res)=>{
                                        return res;
                                    })
    return retVal;

}

export const useSetClientStorage = () => {
    const queryClient = useQueryClient();
    const authInfo = getLocalStorage();
    return useMutation(
        (sendParam) => {
            switch(sendParam.mode){
                case 'SUBS':
                    return postClientStorage(sendParam, authInfo ? authInfo.accessToken:'');
                case 'SUBS_MOD':
                    return putClientStorage({...sendParam,is_cre:2}, authInfo ? authInfo.accessToken:'')
                case 'COMPLETE':
                    return putClientStorage({...sendParam,is_cre:1}, authInfo ? authInfo.accessToken:'')
            }
        },
        {
            onSuccess:()=>{
                queryClient.invalidateQueries([`${queryName}`], { refetchInactive: true })
                queryClient.invalidateQueries([`${queryName}_TARGET`], { refetchInactive: true })
            },
            onError:(err)=>{
                err.response.status===401 ? authExpired(queryClient)
                    : queryClient.setQueryData([MODAL_QUERY_NM],{show:true,msg:err.response.data.message})
            }
        }
    )
}

const postClientStorage = async (param, authInfo) => {

    const sendParam = {
        cid: param.cid,
        dir_nm : param.dir_nm,
        vol_nm: (param.vol_nm && param.vol_nm.length > 0 && param.vol_nm !== 'N')  ? param.vol_nm : null,
        id: param.clientId.trim(),
        pass: param.pass,
        is_cre: 0
    }

    const retVal = await instance.post(contextPath[1], sendParam,{headers:{Authorization:`Bearer ${authInfo}`}})
                                    .then((res)=>{
                                        return res;
                                    })
    return retVal;

}

const putClientStorage = async (param, authInfo) => {

    const sendParam = {
        cid: param.cid,
        dir_nm : param.dir_nm,
        vol_nm: (param.vol_nm && param.vol_nm.length > 0 && param.vol_nm !== 'N')  ? param.vol_nm : null,
        id: param.clientId.trim(),
        pass: param.pass,
        is_cre: param.is_cre
    }

    const retVal = await instance.put(contextPath[1], sendParam,{headers:{Authorization:`Bearer ${authInfo}`}})
                                    .then((res)=>{
                                        return res;
                                    })
    return retVal;

}

export const getClientFromBizno = async (param) => {
    const apiKey = 'Y2hwYXJrQGhpLXRkbi5jb20g'
    return await axios.get(`https://bizno.net/api/fapi?key=${apiKey}&type=json&gb=${param.searchMode}&q=${param.value}`)
                                .then((res)=>{
                                    return res.data.items;
                                })
}

export const getCompanyInfo = async (param) => {
    const url = contextPath[2]+'/'+param;

    const retVal = await instance.get(url,{} )
                                    .then((res)=>{
                                        return res.data;
                                    })
                                    .catch((err)=>{
                                        console.log(err)
                                        return {err:true,message:err.response.data.message};
                                    })


    return retVal;

}